import { Injectable } from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ApiService} from './api.service';
import {Widget} from '../restaurant-manager.models';

@Injectable({
  providedIn: 'root'
})
export class WidgetService {

  constructor(private apiService: ApiService) {}

  getWidgetByRestaurant(restaurantId: string, widgetSlug: string): Observable<Widget> {
    return this.apiService.get<Widget>('/restaurants/' + restaurantId + '/widgets/' + widgetSlug, false).pipe(map((widget: Widget) => {
      return widget ? new Widget(widget) : null;
    }));
  }

}
